var render = function render(){var _vm=this,_c=_vm._self._c;return _c('PrintPackagesDatatable',{attrs:{"print-packages":_vm.printPackages,"loading":_vm.loading,"total":_vm.total},on:{"update":_vm.onUpdate}})
}
var staticRenderFns = []

export { render, staticRenderFns }